import { requestEmailAuth } from '@modusign/openapi-client-user';
import { all, call, put, takeEvery, takeLeading } from 'redux-saga/effects';

import GLOBAL_ERROR_MESSAGE from '@app/constants/errorMessages';
import {
  signUpEmailResend,
  signUpEmailResendFailure,
  signUpEmailResendSuccess,
} from '@app/store/account/sign-up/actions';
import {
  ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST,
  ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS,
} from '@app/store/actionTypes';
import { modalOpen } from '@app/store/modal/actions';

export function* resendAuthenticationEmail({
  payload: email,
}: ReturnType<typeof signUpEmailResend>) {
  try {
    const data: { message: string } = yield call(
      requestEmailAuth,
      { email },
      { credentials: false }
    );
    yield put(signUpEmailResendSuccess(data));
  } catch (error) {
    yield put(signUpEmailResendFailure(error));
  }
}

const VERIFICATION_RESPONSE: { [key: string]: string } = {
  'email authentication requested': '재전송을 완료했습니다.',
};

export function* notifyResendVerificationEmail({
  payload: { message },
}: ReturnType<typeof signUpEmailResendSuccess> | ReturnType<typeof signUpEmailResendFailure>) {
  yield put(
    modalOpen('CONFIRM', {
      content: VERIFICATION_RESPONSE[message] || GLOBAL_ERROR_MESSAGE[message] || message,
    })
  );
}

export default function* saga() {
  yield all([
    takeLeading(ACCOUNT_SIGN_UP_EMAIL_RESEND_REQUEST, resendAuthenticationEmail),
    takeEvery(
      [ACCOUNT_SIGN_UP_EMAIL_RESEND_SUCCESS, ACCOUNT_SIGN_UP_EMAIL_RESEND_FAILURE],
      notifyResendVerificationEmail
    ),
  ]);
}
